/**
 * MapSearch
 */

/* global google */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/actionCreators';
import { trackMapSearch } from '../../utils/analytics';

class MapSearch extends React.Component {
    constructor(props) {
        super(props);
    }

    escFunction = event => {
        if(event.keyCode === 27) {
            this.props.setListActive(false);
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }

    onChange = e => {
        this.props.setListActive(true);
        this.props.setSearchvalue(e.target.value);
    };

    submitSearch = e => {
        e.preventDefault();
        const { items } = this.props;
        let { searchValue } = this.props;

        searchValue = searchValue.trim()

        trackMapSearch(searchValue);

        this.props.setListActive(false);

        if (/^\d{4}$/.test(searchValue) || /^\d{6}$/.test(searchValue)) {
            const marker = items.filter(item => {
                return item.machines.some(machine =>
                    new RegExp(`^${searchValue}`, 'g').test(machine.machine_id)
                );
            })[0];

            if (!marker) {
                return false;
            }

            const center = {
                lat: marker.point.coordinates[1],
                lng: marker.point.coordinates[0]
            };
            this.props.setCenter(center);
            this.props.setZoom(this.props.zoom);
        } else {
            return fetch(
                `/proxy-google.php?service=geocode&address=${encodeURI(
                    searchValue
                )}&language=sv&region=sv&key=${this.props.googleMapKey}`,
                {
                    method: 'get'
                }
            )
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    if (json.status.toLowerCase() === 'ok') {
                        const bounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(
                                json.results[0].geometry.viewport.southwest.lat,
                                json.results[0].geometry.viewport.southwest.lng
                            ),
                            new google.maps.LatLng(
                                json.results[0].geometry.viewport.northeast.lat,
                                json.results[0].geometry.viewport.northeast.lng
                            )
                        );
                        this.props.map.fitBounds(bounds);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    };

    render() {
        const { labels, showList, searchValue } = this.props;

        return (
            <form className="MapSearch" onSubmit={this.submitSearch} action="">
                <input
                    id="mapsearch"
                    value={searchValue}
                    className="MapSearch__Field"
                    ref="input"
                    type="text"
                    placeholder={labels.searchPlaceholder}
                    onChange={this.onChange}
                    onKeyDown={this.onKeyDown}
                    onFocus={showList}
                    aria-label={labels.searchMap}
                    autoComplete="off"
                    tabIndex="0"
                />
            </form>
        );
    }
}

MapSearch.defaultProps = {
    googleMapKey: '',
    labels: {}
};

function mapStateToProps(state) {
    return {
        map: state.map.map,
        items: state.map.items,
        zoom: state.map.zoom,
        searchValue: state.map.searchValue
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapSearch);
